import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c7651a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-pdf" }


import FirstPdfPage from '@/pages/PeriodontalPage/components/pdf/FirstPdfPage.vue'
import SecondPdfPage from '@/pages/PeriodontalPage/components/pdf/SecondPdfPage.vue'
import {
  CommentType,
  ConsolidatedDataType,
  ConsolidatedTableType,
  PeriodontalDetailType,
  PeriodontalReportType,
} from '@/shared/types'

interface Props {
  reportInfo: PeriodontalDetailType
  data: PeriodontalReportType
  previousData: PeriodontalReportType
  plaque: number
  reCleaning: number
  bleeding: number
  suppuration?: number
  pockets: number
  pocketsTable: ConsolidatedTableType[]
  comments: CommentType[]
  consolidatedData: ConsolidatedDataType
}


export default /*#__PURE__*/_defineComponent({
  props: {
    reportInfo: null,
    data: null,
    previousData: null,
    plaque: null,
    reCleaning: null,
    bleeding: null,
    suppuration: null,
    pockets: null,
    pocketsTable: null,
    comments: null,
    consolidatedData: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FirstPdfPage, {
      data: __props.data,
      "previous-data": __props.previousData,
      "report-info": __props.reportInfo,
      class: "periodontal-pdf__page"
    }, null, 8, ["data", "previous-data", "report-info"]),
    _createVNode(SecondPdfPage, {
      "re-cleaning": __props.reCleaning,
      bleeding: __props.bleeding,
      comments: __props.comments,
      "consolidated-data": __props.consolidatedData,
      data: __props.data,
      "previous-data": __props.previousData,
      plaque: __props.plaque,
      pockets: __props.pockets,
      "pockets-table": __props.pocketsTable,
      class: "periodontal-pdf__page"
    }, null, 8, ["re-cleaning", "bleeding", "comments", "consolidated-data", "data", "previous-data", "plaque", "pockets", "pockets-table"])
  ]))
}
}

})